import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FiChevronRight } from 'react-icons/fi'
import { Post } from '../../web_api/api'
import Swal from 'sweetalert2'
import '../../branch/branch.css'

export default function PromoCreate() {

    const [image, setImage] = useState(null)
    const [title, setTitle] = useState('')
    const [subTitle, setSubTitle] = useState('')
    const [description, setDescription] = useState('')


    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0])
        }
    }
    const create = async () => {
        const formData = new FormData()
        formData.append('title', title)
        formData.append('sub_title', subTitle)
        formData.append('description', description)
        formData.append('promotions', image)

        if (!image) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                // showCancelButton: true,

                showConfirmButton: false,
                timer: 2000
            })
        } else {
            const createTreatment = await Post('/promotion-pages', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            // console.log(createTreatment, 'createTreatment')
        }

    }

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/promotion'>Promotions</Link>
                <FiChevronRight className='separator' size={14} />
                <span className='current'>Create Promotion</span>
            </div>

            <div className='branch-page-title'>Create Promotion</div>
            <div className='branch-page-subtitle'>Add a new promotion</div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Promotion Details</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='title'>Title</label>
                                    <input type='text' id='title' placeholder='Title' className='branch-input' onChange={(e) => setTitle(e.target.value)} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='subTitle'>Sub Title</label>
                                    <input type='text' id='subTitle' placeholder='Sub Title' className='branch-input' onChange={(e) => setSubTitle(e.target.value)} />
                                </div>
                            </div>

                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Content</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='description'>Description</label>
                                    <textarea id='description' placeholder='Write description ...' className='branch-input' onChange={(e) => setDescription(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Image</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='imageInput'>
                                        Image <span className='required'>*</span>
                                    </label>
                                    <input type='file' id='imageInput' className='branch-input' onChange={handleImageChange} />
                                </div>
                                {image && (
                                    <div className='branch-field'>
                                        <img src={URL.createObjectURL(image)} className='mt-2' style={{ maxWidth: 200, maxHeight: 200 }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='branch-form-footer'>
                        <Link to='/website-dashboard' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={create}>Create</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
